import { createContext, useContext, type ReactNode } from 'react';
import {
  useChannelsProfileStorage,
  type Profile,
  type ProfileGeneration,
} from '../utils/profiler-helper';

export type ChannelsProfileValue = {
  profiles: Profile[];
  currentProfile: Profile;
  currentProfileId: string;
  hiddenChannelIds: string[];
  switchProfile: (id: string, generation?: ProfileGeneration) => void;
  deleteProfile: (id: string) => void;
  saveProfile: (profile: Profile) => void;
  setChannelOrder: (channelIds: string[]) => void;
  setChannelHidden: (channelId: string, hidden: boolean) => void;
};

const ChannelsProfileContext = createContext<ChannelsProfileValue | null>(null);

export const ChannelsProfileProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const value = useChannelsProfileStorage();
  return (
    <ChannelsProfileContext.Provider value={value}>
      {children}
    </ChannelsProfileContext.Provider>
  );
};

export const useChannelsProfile = (): ChannelsProfileValue => {
  const value = useContext(ChannelsProfileContext);
  if (!value) {
    throw new Error(
      'useChannelsProfile must be used inside a ChannelsProfileProvider',
    );
  }
  return value;
};
